<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div class="row content-add-btn">
            <div class="col-4" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/users/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('config.add_user') }}
                </button>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <el-dialog
              top="2%"
              width="70%"
              v-if="isShow()"
              :title="title"
              :visible.sync="modals.read"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body" v-if="rowData">
                  <table class="table">
                    <tbody v-if="rowData">
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.names') }}: </strong>
                          </h6>
                          {{ rowData.first_name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.surnames') }}: </strong>
                          </h6>
                          {{ rowData.last_name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>
                              {{ $t('common_words.username') }}:
                            </strong>
                          </h6>
                          {{ rowData.username }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>
                              {{ $t('common_words.document_number') }}:
                            </strong>
                          </h6>
                          {{ rowData.document_id }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong> {{ $t('common_words.email') }}: </strong>
                          </h6>
                          {{ rowData.email }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong> {{ $t('common_words.nfc') }}: </strong>
                          </h6>
                          {{ rowData.nfc_id }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6
                            style="
                              height: 30px;
                              line-height: 20px;
                              display: inline-flex;
                            "
                          >
                            <strong>
                              {{ $t('common_words.temporary_password') }}:
                            </strong>
                            <el-switch
                              class="ml-3"
                              style="display: block"
                              v-bind:value="
                                rowData.temporary_password == 1 ? true : false
                              "
                              active-color="#20a857"
                              inactive-color="#ff4c4c"
                            >
                            </el-switch>
                          </h6>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong> {{ $t('common_words.profile') }}: </strong>
                          </h6>
                          <el-tag type="info" v-if="rowData.role_name">{{
                            rowData.role_name[0]
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{ $t('common_words.associated_companies') }}:
                            </strong>
                          </h6>
                          <span
                            v-for="(business, index) in rowData.business"
                            v-bind:key="index"
                          >
                            <el-tag type="info">{{ business.name }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{ $t('common_words.associated_farms') }}:
                            </strong>
                          </h6>
                          <span
                            v-for="(farm, index) in rowData.farms"
                            v-bind:key="index"
                          >
                            <el-tag type="info">{{ farm.name }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_permissions')
                              }}:</strong
                            >
                          </h6>
                          <el-tag
                            v-if="rowData.role_type == 'super administrador'"
                            type="info"
                            >{{ $t('common_words.super_admin') }}</el-tag
                          >
                          <span
                            v-else
                            v-for="(
                              permission, index
                            ) in rowData.all_permissions"
                            v-bind:key="index"
                          >
                            <el-tag type="info">{{
                              permission.module
                                ? `${permission.name} en ${permission.module}`
                                : permission.name
                            }}</el-tag>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-white">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
            <el-dialog :title="title" :visible.sync="modals.roles">
              <span>{{ $t('config.select_profile') }}:</span><br /><br />
              <el-select
                clearable
                class="select-primary custom-width-select shadow-sm required-rol"
                v-model.number="userForm.role_id"
                filterable
                :placeholder="$t('common_words.select_a_profile')"
              >
                <el-option
                  v-for="optiona in roles"
                  class="select-primary"
                  :value="optiona.id"
                  :label="optiona.name"
                  :key="optiona.name"
                >
                </el-option>
              </el-select>
              <span slot="footer" class="dialog-footer">
                <button class="btn btn-danger" @click="closeModal('roles')">
                  {{ $t('common_words.cancel') }}</button
                >&nbsp;
                <button class="btn btn-success" @click="changeRol()">
                  {{ $t('common_words.confirm') }}
                </button>
              </span>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                class="no-capitalize"
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="650"
                style="width: 100%"
                border
              >
                <el-table-column
                  type="index"
                  width="80"
                  align="center"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :align="column.align"
                  :sortable="column.sortable"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  min-width="130"
                  prop="props.business"
                  :label="$t('common_words.associated_companies')"
                  :sortable="true"
                  :resizable="false"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.business.length > 0"
                      :hidden="scope.row.business.length == 1 ? true : false"
                      :value="200"
                      :max="scope.row.business.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.business[0].name }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="110"
                  prop="props.farms"
                  :label="$t('common_words.associated_farms')"
                  :sortable="true"
                  :resizable="false"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.farms.length > 0"
                      :hidden="scope.row.farms.length == 1 ? true : false"
                      :value="200"
                      :max="scope.row.farms.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.farms[0].name }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  :label="$t('common_words.active_session_question')"
                  :align="'center'"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <el-switch
                      style="display: block"
                      v-bind:value="
                        props.row.active_session == 1 ? true : false
                      "
                      active-color="#6BA652"
                      inactive-color="#ff4c4c"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="
                    isShow() ||
                    isManagementRole() ||
                    isManagementPassword() ||
                    isUpdate() ||
                    isDelete()
                  "
                  :min-width="120"
                  fixed="right"
                  :label="$t('common_words.operations')"
                  :align="'center'"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.see')"
                      class="btn-info btn-simple btn-link"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye"></em
                    ></a>
                    <a
                      v-if="isManagementRole()"
                      v-tooltip.top-center="$t('config.manage_profile')"
                      class="btn-success btn-simple btn-link"
                      @click="handleRol(props.$index, props.row)"
                      ><em class="fa fa-tag"></em
                    ></a>
                    <a
                      v-if="isManagementPassword()"
                      v-tooltip.top-center="
                        $t('common_words.temporary_password')
                      "
                      class="btn-success btn-simple btn-link"
                      @click="handleTemporary(props.$index, props.row)"
                      ><em class="fa fa-key"></em
                    ></a>
                    <a
                      v-if="isManagementSession()"
                      v-tooltip.top-center="
                        `${$t('config.close_all_active_sessions')}  `
                      "
                      class="btn-success btn-simple btn-link"
                      @click="handleCloseUserSession(props.$index, props.row)"
                      ><em class="fa fa-power-off"></em>
                    </a>
                    <a
                      v-if="isManagementSession()"
                      v-tooltip.top-center="
                        $t('config.close_all_mobile_active_sessions')
                      "
                      class="btn-info btn-simple btn-link"
                      @click="
                        handleCloseUserSessionMobile(props.$index, props.row)
                      "
                      ><em class="fa fa-power-off"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link"
                      @click="handleEdit(props.$index, props.row)"
                      ><em class="fa fa-edit"></em
                    ></a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="getTextTooltipDelete(props.row)"
                      :class="`btn-${
                        props.row.deleted_at ? `info` : `danger`
                      } btn-simple btn-link custom-margin-actions`"
                      @click="
                        props.row.deleted_at
                          ? handleActivate(props.$index, props.row)
                          : handleDelete(props.$index, props.row)
                      "
                    >
                      <em
                        :class="`fa ${
                          props.row.deleted_at ? `fa-check-circle` : `fa-times`
                        } custom-size-fa-actions`"
                      ></em>
                    </a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('table.showing') }} {{ from + 1 }} {{ $t('table.to') }}
                {{ to }} {{ $t('table.of') }} {{ total }}
                {{ $t('table.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="row" style="padding-right: 13px; padding-left: 13px">
      <div class="col-6" v-if="isPDF()">
        <div class="text-right">
          <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
            <em class="fa fa-file-pdf-o"></em>
            {{ $t('common_words.export_to_pdf') }}
          </button>
        </div>
      </div>
      <div class="col-6" v-if="isExcel()">
        <div class="text-left">
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="exportToExcel"
          >
            <em class="fa fa-file-excel-o"></em>
            {{ $t('common_words.export_to_excel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Pagination as LPagination } from 'src/components/index';
import axios from 'axios';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import configTable from './userTable';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: configTable().Search,

  data() {
    return {
      userForm: {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        temporary_password: null,
        role_id: '',
        permissions_ids: [],
      },

      modals: {
        read: false,
        temporary: false,
        roles: false,
      },

      roles: null,
      title: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    ...mapActions({
      attempt: 'auth/attempt',
    }),

    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    getTextTooltipDelete(row) {
      if (row.deleted_at) return i18n.t('common_words.activate');
      else return i18n.t('common_words.deactivate');
    },

    handleView(index, row) {
      this.title = `${i18n.t('config.user')}: ${row.name}`;
      this.rowData = Object.assign({}, row);
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/users/edit';
      this.userForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.userForm));
      this.$router.push({ path: 'users/edit' });
    },

    handleDelete(index, row) {
      this.userForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('config.the_user') + ' ' + this.userForm.name
      ).then((result) => {
        if (result.value) this.deleteUser();
      });
    },

    handleActivate(index, row) {
      this.userForm = Object.assign({}, row);
      SweetAlert.confirm(
        i18n.t('common_words.activate') +
          ' ' +
          i18n.t('config.the_user') +
          ' ' +
          this.userForm.name,
        i18n.t('show_notification.users.activate_user_confirm')
      ).then((result) => {
        if (result.value) this.activateUser();
      });
    },

    handleRol(index, row) {
      this.title = `${i18n.t('config.manage_profile2')}: ${row.name}`;
      this.userForm = Object.assign({}, row);
      this.userForm.route = 'users';
      //this.assignFieldIds(row)
      this.userForm.role_id = parseInt(row.role_id);

      let sn = false;
      this.roles.forEach((element) => {
        if (element.id == this.userForm.role_id) {
          sn = true;
          return;
        }
      });

      if (!sn) this.userForm.role_id = '';

      this.modals['roles'] = true;
    },

    handleTemporary(index, row) {
      this.userForm = Object.assign({}, row);
      //this.assignFieldIds(row)
      SweetAlert.temporary(
        i18n.t('config.activate_temporary_password'),
        i18n.t('config.confirm_activate_temporary_password') +
          this.userForm.name +
          '?'
      ).then((result) => {
        if (result.value) this.temporaryUser();
      });
      this.openModal('temporary');
    },

    handleCloseUserSession(index, row) {
      SweetAlert.temporary(
        i18n.t('config.close_all_active_sessions'),
        i18n.t('config.confirm_close_all_active_sessions') +
          ' ' +
          row.name +
          i18n.t('config.in_other_teams'),
        i18n.t('config.close_active_sessions')
      ).then((result) => {
        if (result.value) {
          this.closeUserSession(row.id);
        }
      });
      this.openModal('temporary');
    },
    handleCloseUserSessionMobile(index, row) {
      SweetAlert.temporary(
        i18n.t('config.close_all_mobile_active_sessions'),
        i18n.t('config.confirm_close_all_mobile_active_sessions') +
          '' +
          row.name +
          ' ' +
          i18n.t('config.in_other_devices'),
        i18n.t('config.close_active_sessions')
      ).then((result) => {
        if (result.value) {
          this.closeUserSessionMobile(row.id);
        }
      });
      this.openModal('temporary');
    },

    temporaryUser() {
      this.showHideLoading(true);
      axios
        .put('auth/users/temporary/' + this.userForm.id)
        .then((response) => {
          let index = this.tableData.findIndex(
            (tableRow) => tableRow.id === this.userForm.id
          );
          this.$set(this.tableData, index, response.data.data);
          this.closeModal('temporary');
          this.showNotification(
            `${response.data.message}`,
            'success',
            'nc-key-25',
            i18n.t('common_words.success_operation') + '...'
          );
          this.showHideLoading();
        })
        .catch((error) => {
          this.closeModal('temporary');
          this.showMessageErrors(error);
        });
    },

    closeUserSession(user) {
      this.showHideLoading(true);
      axios
        .post('auth/users/closesession', { id: user })
        .then((response) => {
          let index = this.tableData.findIndex(
            (tableRow) => tableRow.id === user
          );
          this.tableData[index].active_session_label = 'No';
          this.showNotification(
            `${response.data.message}`,
            'success',
            'nc-key-25',
            i18n.t('common_words.success_operation') + '...'
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    closeUserSessionMobile(user) {
      this.showHideLoading(true);
      axios
        .post('auth/users/closesession/mobile', { id: user })
        .then((response) => {
          this.showNotification(
            `${response.data.message}`,
            'success',
            'nc-key-25',
            i18n.t('common_words.success_operation') + '...'
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    deleteUser() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.userForm.route = 'users';
        Axios.destroyMaster(this.userForm)
          .then((response) => this.modifyTable(1, this.userForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    activateUser() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.userForm.route = 'users/activate';
        Axios.updateMaster(this.userForm)
          .then((response) => this.modifyTable(1, this.userForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    changeRol() {
      if (this.userForm.role_id.length == 0) {
        for (let index of document.getElementsByClassName('required-rol')) {
          let sel = index.getElementsByClassName('el-input__inner')[0];
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
        }
      } else {
        this.showHideLoading(true);
        axios
          .post('auth/users/rol/' + this.userForm.role_id, this.userForm)
          .then((response) => {
            let index = this.tableData.findIndex(
              (tableRow) => tableRow.id === this.userForm.id
            );
            this.$set(this.tableData, index, response.data.data);
            this.closeModal('roles');
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-settings-90',
              i18n.t('common_words.success_operation') + '...'
            );
            this.showHideLoading();
            this.forceRenderMenu();
          })
          .catch((error) => {
            this.closeModal('roles');
            this.showMessageErrors(error);
          });
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'users/pdf';
      data.name_file = `${i18n.t('config.user')}s.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'users/excel';
      data.name_file = `${i18n.t('config.user')}s.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('users')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });

          Axios.getMasters('roles/indexfield')
            .then((response1) => {
              this.roles = response1.data.data;
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('users');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('users');
  },
};
</script>
<style></style>
